export const OrdenesVentasLang = {
    TituloOrden: {
        es: 'Orden Venta',
        en: 'Sales Order'
    },
    NoOrder: {
        es: 'No. Orden',
        en: 'No. Order'
    },
    CustomerOrder: {
        es: 'Orden Cliente',
        en: 'Customer PO'
    },
    Status: {
        es: 'Estado',
        en: 'Status'
    },
    Customer: {
        es: 'Cliente',
        en: 'Customer'
    },
    Buyer: {
        es: 'Buyer',
        en: 'Comprador'
    },
    SalesAgent: {
        es: 'Agente Ventas',
        en: 'Sales Agent'
    },  
    CustomerServiceAgent: {
        es: 'Agente Servicio Cliente',
        en: 'Customer Service Agent'
    },
    OrderDate: {
        es: 'Fecha Orden',
        en: 'Order Date'
    },
    RequiredDate: {
        es: 'Fecha Requerida',
        en: 'Required Date'
    },
    Payment: {
        es: 'Pago',
        en: 'Payment'
    },
    Type: {
        es: 'Tipo',
        en: 'Type'
    },
    Terms: {
        es: 'Términos',
        en: 'Terms'
    },
    Adds: {
        es: 'Agregados',
        en: 'Adds'
    },
    OrderType: {
        es: 'Tipo Orden',
        en: 'Order Type'
    },
    Depto: {
        es: 'Depto:',
        en: 'Dept:'
    },
    ISD: {
        es: 'ISD:',
        en: 'ISD:'
    },
    Season: {
        es: 'Temporada:',
        en: 'Season:'
    },
    Program: {
        es: 'Programa:',
        en: 'Program:'
    },
    ComentarioGeneral: {
        es: 'Comentario General',
        en: 'General Comment'
    },
    Revisado: {
        es: 'Revisado',
        en: 'Revised'
    },
    Brand: {
        es: 'Marca:',
        en: 'Brand:'
    },
    InventoryTerms: {
        es: 'Términos de inventario',
        en: 'Inventory Terms'
    },
    localOtros: {
        es: 'Local/Otros',
        en: 'Local/Others'
    },
    orderAgent: {
        es: 'Agente de orden',
        en: 'Order Agent'
    },
    PaymentTerm: {
        es: 'Términos de pago',
        en: 'Payment Terms'
    },
    TituloReporte: {
        es: 'ORDEN DE VENTA',
        en: 'SALES ORDER',
    },
    fecha: {
        es: 'Fecha',
        en: 'Date',
    },
    direccion: {
        es: 'Dirección: ',
        en: 'Address: ',
    },
    customerOrder: {
        es: 'Orden de Cliente',
        en: 'Customer Order',
    },
    agente: {
        es: 'Agente de Ventas',
        en: 'Sales Agent',
    },
    cliente: {
        es: 'Cliente',
        en: 'Customer',
    },
    terminoEnvio: {
        es: 'Término de Envío',
        en: 'Shipping Term',
    },
    terminoVenta: {
        es: 'Término de Venta',
        en: 'Term of Sale',
    },
    estado: {
        es: 'Estado',
        en: 'Status',
    },
    yarn: {
        es: 'HILO',
        en: 'YARN',
    },
    fechaExportancion: {
        es: 'EXPORTACION',
        en: 'EXPORT',
    },
    Cantidad: {
        es: 'CANTIDAD',
        en: 'QUANTITY',
    },
    PrecioL: {
        es: 'PRECIO L',
        en: 'PRICE L',
    },
    SubTotalL: {
        es: 'SUBTOTAL L',
        en: 'SUBTOTAL L',
    },
    comentario: {
        es: 'Comentario',
        en: 'Comment',
    },
    fechaImpresion: {
        es: 'Fecha de Impresión: ',
        en: 'Print Date: ',
    },
    Season: {
        es: 'Season',
        en: 'Estación',
    },
    SalesDirector: {
        es: 'Director Ventas',
        en: 'Sales Director',
    },
    AccountManager: {
        es: 'Gerente cuentas',
        en: 'Account Manager',
    },
    SalesManager: {
        es: 'Gerente Ventas',
        en: 'Sales Manager',
    },
    Category: {
        es: 'Categoría',
        en: 'Category',
    },
    OrderTerms: {
        es: 'Término de Orden',
        en: 'Order Terms',
    },
    Style: {
        es: 'FABRIC',
        en: 'TELA',
    },
    WorkFlow: {
        es: 'FLUJO DE TRABAJO',
        en: 'WORK FLOW',
    },
    Fabric: {
        es: 'Cantidad de pedido de tela',
        en: 'Fabric Order Quantity',
    },

}